import React from 'react';

const FeatureBlock = (props) => (
  <div className="feature">
    <div className="small-circle">
      <img src={props.icon}/>
    </div>
    <h4>
      {props.title}
    </h4>
    <div className="description">
      {props.description}
    </div>
  </div>
);

export default FeatureBlock;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/FeatureBlock.jsx